import { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import "./Training.css";
import {
  training_accessibility,
  training_document_delivery,
  training_duration,
  training_participants,
  training_pedagogic_method,
  training_prerequisites,
  training_target,
} from "../../Imgs/images";
import TrainingPrices from "./TrainingPrices/TrainingPrices";

interface TrainingsProps {
  type: string;
}

const filesByType: any = {
  formation: "formations.json",
  supervision: "supervisions.json",
  "service-entreprises": "services.json",
};

function Training(props: TrainingsProps) {
  let { id } = useParams();

  const [training, setTraining] = useState<any>({});

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_DOMAIN}api/trainings/${filesByType[props.type]}`,
    )
      .then((response) => response.json())
      .then((response: Array<any>) => {
        for (const [, training] of Object.entries(response)) {
          let trainingId = -1;
          if (typeof id === "string") trainingId = parseInt(id);
          if (trainingId === training?.id) {
            setTraining(training);
            break;
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id, props.type]);

  const defineProgramPoints = (points: any) => {
    if (points == null) return;

    return (
      <ul className="training-program-list">
        {points.map((point: any, idx: number) => (
          <li key={"points-" + idx} className="training-program-item">
            {point.title}

            {point.subpoints && point.subpoints.length > 0 && (
              <ul
                key={"subpoint-" + idx}
                className="training-prog-item-subpoints"
              >
                {point.subpoints.map((subPoint: string, index: number) => (
                  <li
                    key={idx + "-" + index}
                    className="training-prog-item-subpoint"
                  >
                    {subPoint}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <Header additionalClass={props.type} />
      <section className="training-intro">
        <picture className="training-intro-bg-img">
          <source
            srcSet={`${process.env.REACT_APP_DOMAIN}Imgs/${training?.imgTraining}`}
          />
          <img
            src={`${process.env.REACT_APP_DOMAIN}Imgs/${training?.imgTraining}`}
            alt=""
          />
        </picture>
        <div className="training-intro-content">
          <h1 className="training-intro-title">{training?.title}</h1>
          <p className="training-intro-description">{training?.description}</p>
        </div>
      </section>
      <section className={`training-infos training-${props?.type}`}>
        <div className="training-infos-program">
          <h2 className="training-program-title">Programme de la formation</h2>
          {defineProgramPoints(training?.program?.points)}
        </div>
        <div className="training-infos-additional">
          <div className="training-additional-item">
            <div className="training-additional-header">
              <picture className="training-additional-item-img">
                <source srcSet={training_target} />
                <img src={training_target} alt="" />
              </picture>
              <h3 className="training-additional-title">Public visé</h3>
            </div>
            <p className="training-additional-text">
              {parse(training?.public || "")}
            </p>
          </div>
          <div className="training-additional-item">
            <div className="training-additional-header">
              <picture className="training-additional-item-img">
                <source srcSet={training_prerequisites} />
                <img src={training_prerequisites} alt="" />
              </picture>
              <h3 className="training-additional-title">Pré-requis</h3>
            </div>
            <ul className="training-additional-text">
              {training.prerequisites &&
                training.prerequisites.length > 0 &&
                training.prerequisites.map(
                  (prerequisite: string, idx: number) => {
                    return (
                      <li
                        key={"prerequisite-" + idx}
                        className="training-prerequisite"
                      >
                        {prerequisite}
                      </li>
                    );
                  },
                )}
            </ul>
          </div>
          <div className="training-additional-item">
            <div className="training-additional-header">
              <picture className="training-additional-item-img">
                <source srcSet={training_participants} />
                <img src={training_participants} alt="" />
              </picture>
              <h3 className="training-additional-title">
                Nombre de participants
              </h3>
            </div>
            <p className="training-additional-text training-additional-text-bigger">
              {parse(training?.participants || "")}
            </p>
          </div>
          <div className="training-additional-item training-additional-public">
            <div className="training-additional-header">
              <picture className="training-additional-item-img">
                <source srcSet={training_duration} />
                <img src={training_duration} alt="" />
              </picture>
              <h3 className="training-additional-title">
                Durée de la formation
              </h3>
            </div>
            <p className="training-additional-text training-additional-text-bigger">
              {parse(training?.duration || "")}
            </p>
          </div>
          <div className="training-additional-item">
            <div className="training-additional-header">
              <picture className="training-additional-item-img">
                <source srcSet={training_accessibility} />
                <img src={training_accessibility} alt="" />
              </picture>
              <h3 className="training-additional-title">Accessibilité</h3>
            </div>
            <p className="training-additional-text">
              {parse(training?.accessibility || "")}
            </p>
          </div>
        </div>
      </section>
      <section className="training-infos">
        <div className="training-pedagogic-method">
          <div className="training-additional-item">
            <div className="training-additional-header">
              <picture className="training-additional-item-img">
                <source srcSet={training_pedagogic_method} />
                <img src={training_pedagogic_method} alt="" />
              </picture>
              <h3 className="training-additional-title">Méthode pédagogique</h3>
            </div>
            <ul className="training-additional-text">
              {training.pedagogicMethods &&
                training.pedagogicMethods.length > 0 &&
                training.pedagogicMethods.map(
                  (pedagogicMethod: string, idx: number) => {
                    return (
                      <li
                        key={"prerequisite-" + idx}
                        className="training-prerequisite"
                      >
                        {pedagogicMethod}
                      </li>
                    );
                  },
                )}
            </ul>
          </div>
        </div>
        <div className="training-document-deliveries">
          <div className="training-additional-item">
            <div className="training-additional-header">
              <picture className="training-additional-item-img">
                <source srcSet={training_document_delivery} />
                <img src={training_document_delivery} alt="" />
              </picture>
              <h3 className="training-additional-title">Documents délivrés</h3>
            </div>
            <ul className="training-additional-text">
              {training.documentDeliveries &&
                training.documentDeliveries.length > 0 &&
                training.documentDeliveries.map(
                  (documentDelivery: string, idx: number) => {
                    return (
                      <li
                        key={"prerequisite-" + idx}
                        className="training-prerequisite"
                      >
                        {documentDelivery}
                      </li>
                    );
                  },
                )}
            </ul>
          </div>
        </div>
      </section>
      <TrainingPrices rates={training?.rates} type={props?.type} />
      <section className={`training-must-have training-${props?.type}`}>
        <div className="training-must-have-content">
          <h2 className="training-must-have-title">
            {training?.mustHave?.title}
          </h2>
          <ul className="training-must-have-list">
            {training?.mustHave?.points &&
              training?.mustHave?.points?.length > 0 &&
              training.mustHave.points.map((point: string, idx: number) => {
                return (
                  <li
                    key={"must-have-point-" + idx}
                    className="training-must-have-point"
                  >
                    {point}
                  </li>
                );
              })}
          </ul>
        </div>
      </section>
      {/* <section className={`training-photos training-${props?.type}`}>
        {training?.photos?.map((photo: string, idx: number) => {
          if (idx < 4)
            return (
              <div key={"photos-" + idx} className={`training-photo-${idx}`}>
                <picture className="training-photo-picture">
                  <source
                    srcSet={`${process.env.REACT_APP_DOMAIN}Imgs/${photo}`}
                  />
                  <img
                    src={`${process.env.REACT_APP_DOMAIN}Imgs/${photo}`}
                    alt=""
                  />
                </picture>
              </div>
            );
          else return null;
        })}
      </section> */}
      <Footer />
    </>
  );
}

export default Training;
